// @ts-nocheck
import { REQUEST_HELP_ERROR, REQUEST_HELP_LOADING, REQUEST_HELP_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const RequestHelpReducer = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_HELP_LOADING:
            return Object.assign({}, state, { loading: true })
        case REQUEST_HELP_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case REQUEST_HELP_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

